import { StyleSheet } from "aphrodite";
import {
  fontSize,
  lineHeight,
} from "main/javascripts/styles/base/typographyStyle";
import { space } from "main/javascripts/styles/base/spaceStyle";
import {
  accentColor,
  borderColor,
  textColor,
} from "main/javascripts/styles/base/colorStyle";
import { moreThanBreakpoint } from "main/javascripts/styles/base/responsiveStyle";

export interface IStyle {
  block: any;
  list: any;
  link: any;
}

export const RegionListStyle: IStyle = StyleSheet.create({
  block: {
    padding: space.atom,
    display: "flex",
    flexWrap: "wrap",
    listStyle: "none",
  },
  list: {
    fontSize: fontSize.caption,
    lineHeight: lineHeight.caption3,
    color: textColor.primaryDarkColor,
    padding: `${space.atom} ${space.atom} ${space.atom} ${space.atom2x}`,
    marginBottom: space.atom0_5x,
    letterSpacing: "0.1em",
    position: "relative",
    width: "100%",
    boxSizing: "border-box",
    ":before": {
      content: "''",
      position: "absolute",
      top: "1rem",
      left: 0,
      display: "block",
      height: "1px",
      width: space.atom,
      background: borderColor.secondaryLightColor,
    },
    [moreThanBreakpoint("tablet")]: {
      width: "50%",
    },
    [moreThanBreakpoint("desktop")]: {
      width: "25%",
    },
  },
  link: {
    color: textColor.primaryDarkColor,
    textDecoration: "none",
    transition: "color 0.4s ease",
    ":hover": {
      color: accentColor.primaryColor,
    },
  },
});
